import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
  Modal,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { FaLink } from "react-icons/fa6";
import { RetailerInvoice } from "./RetailerInvoice";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import NoImageFound from "../../assets/images/No-Image-found.png";

const columns = [
  { id: "order_id", label: "ORDER ID", minWidth: 140, align: "center" },
  { id: "retailer_id", label: "RETAILER ID", minWidth: 150, align: "center" },
  // { id: "ordertype", label: "ORDER TYPE", minWidth: 170, align: "center" },
  {
    id: "invoice_amount",
    label: "INVOICE AMOUNT",
    minWidth: 170,
    align: "center",
  },
  {
    id: "convenience_fee",
    label: "CONVENIENCE FEE",
    minWidth: 170,
    align: "center",
  },
  { id: "ryder_fee", label: "RYDER FEE", minWidth: 130, align: "center" },
  { id: "order_status", label: "STATUS", minWidth: 100, align: "center" },
  {
    id: "created_at",
    label: "INVOICE DATE",
    minWidth: 180,
    align: "center",
  },
  {
    id: "invoice_summary",
    label: "INVOICE SUMMARY",
    minWidth: 100,
    align: "center",
  },
];

function createData(
  retailer_id,
  order_id,
  invoice_amount,
  convenience_fee,
  ryder_fee,
  order_status,
  created_at,
  invoice_summary
) {
  return {
    retailer_id,
    order_id,
    invoice_amount,
    convenience_fee,
    ryder_fee,
    order_status,
    created_at,
    invoice_summary,
  };
}

// const rows = [
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Payment",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Suid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Cancelled",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Cancelled",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
//   createData(
//     "Muid123",
//     "#GMK123",
//     "Credit",
//     "₹ 2710.00",
//     "₹ 14.00",
//     "₹ 14.00",
//     "Closed",
//     "#GMK123"
//   ),
// ];

export function TransactionRetailer() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [RetailerTransactionList, setRetailerTransactionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  const navigate = useNavigate();

  const fetchRetailersTransactions = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/retailer-transaction-list/");
      console.log("✅ Retailers Transactions list response:", res.data);
      if (res.data.status === "success") {
        setRetailerTransactionList(res.data.data || []);
      } else {
        setError("Failed to fetch Retailers Transactions data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Retailers Transactions data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailersTransactions();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const formatValue = (columnId, value) => {
    if (value === null || value === undefined || value === "") return "--";

    if (["invoice_amount", "convenience_fee", "ryder_fee"].includes(columnId)) {
      return `₹ ${parseFloat(value).toFixed(2)}`;
    }

    if (columnId === "order_id") {
      return `#${value}`;
    }

    if (columnId === "retailer_id") {
      return `#${value}`;
    }

    if (columnId === "created_at") {
      const date = new Date(value);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }
    return value;
  };

  const filteredData = RetailerTransactionList.filter((row) =>
    row.order_id?.toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">Retailers Transactions</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                          "&:hover": {
                            backgroundColor: "inherit",
                          },
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];

                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-Wholesalercolumn tableCelldata`}
                              onClick={
                                column.id === "order_id"
                                  ? () =>
                                      navigate(
                                        // `/transaction-retailers-details/${row.order_id}`
                                        `/transaction-retailers-details/${row.orderitem_id}`
                                      )
                                  : undefined
                              }
                              sx={{
                                color:
                                  column.id === "order_status"
                                    ? value === "Closed"
                                      ? "green"
                                      : "red"
                                    : "inherit",
                                cursor:
                                  column.id === "order_id"
                                    ? "pointer"
                                    : "default",
                                color:
                                  column.id === "order_id" ? "#4184D1" : "",
                              }}
                            >
                              {/* {column.id === "invoice_summary" ? (
                                <div
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    navigate("/transaction-retailer-invoice")
                                  }
                                  onClick={() => navigate("/coming-soon")}
                                  onClick={() => {
                                    setImageUrl(value);
                                    setToggleModalOpen(true);
                                  }}
                                >
                                  <span
                                    className="me-2"
                                    style={{ color: "#4184D1" }}
                                  >
                                    <FaLink />
                                  </span>
                                  <span>Link</span>
                                </div>
                              ) : (
                                formatValue(column.id, value)
                              )} */}
                              {column.id === "invoice_summary" ? (
                                value && value !== "null" ? (
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#4184D1",
                                    }}
                                    onClick={() => {
                                      if (value && value.startsWith("http")) {
                                        window.open(value, "_blank");
                                      } else {
                                        toast.error("Invalid invoice link");
                                      }
                                    }}
                                  >
                                    <FaLink className="me-2" />
                                    Link
                                  </div>
                                ) : (
                                  "--"
                                )
                              ) : (
                                formatValue(column.id, value)
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <Modal open={toggleModalOpen} onClose={() => setToggleModalOpen(false)}>
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* ❌ Close Button */}
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">INVOICE SUMMARY</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {imageUrl ? (
              <img
                src={imageUrl || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal>
    </>
  );
}
